import moment from "moment";

const HISTORY_DURATION = 60; // Days

const noticeHistoryStorage = {

    _allNotices: null,

    get allNotices() {
        if (!this._allNotices) {
            this._allNotices = JSON.parse(localStorage.getItem('noticeHistory') || '[]');

            // Remove expired notices from localStorage
            let cleaned = removeExpired(this._allNotices);
            if (this._allNotices.length > cleaned.length) {
                this._allNotices = cleaned;
                localStorage.noticeHistory = JSON.stringify(this._allNotices);
            }
        }

        return this._allNotices;
    },

    set allNotices(notices = []) {
        if (!Array.isArray(notices)) {
            throw 'noticeHistory should be an array';
        }

        this._allNotices = notices;
        localStorage.noticeHistory = JSON.stringify(this.allNotices);
    },

    getNotices(userId) {
        return this.allNotices.filter(notice => notice.userId === userId);
    },

    addNotices(notices = []) {
        /**
         * E.g.: 
         * notices = [
         *  { userId: 'clinton.jr', noticeId: 'xxx1', timestamp: 1690264049978 },
         *  { userId: 'clinton.jr', noticeId: 'xxx3', timestamp: 1690264049978 },
         *  { userId: 'clinton.jr', noticeId: 'xxx8', timestamp: 1690264049978 },
         *  ...
         * ]
         */
        if (!Array.isArray(notices)) {
            throw 'noticeHistory should be an array';
        }

        // Add notices and update to localStorage
        this.allNotices.push(...notices);
        localStorage.noticeHistory = JSON.stringify(this.allNotices);
    }
}

export default noticeHistoryStorage;

const removeExpired = (oldList) => {
    // Exclude notices older than `HISTORY_DURATION`
    let newList = oldList.filter(notice => {
        let noticeExpiry = moment(notice.timestamp).add(HISTORY_DURATION, 'days');
        let now = moment();
        return noticeExpiry.isAfter(now);
    })

    return newList;
}